var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"img-viewer"}},[(_vm.show)?_c('ImageViewer',{attrs:{"z-index":_vm.zIndex,"initial-index":_vm.index,"on-close":_vm.closeImgHandler,"url-list":_vm.urlList}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }